var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.804,
    height: 18.809,
    viewBox: "0 0 18.804 18.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_320",
    "data-name": "Groupe 320",
    transform: "translate(-899.018 -363.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_460",
    "data-name": "Trac\\xE9 460",
    d: "M65.562,293.514a3.308,3.308,0,0,0-2.354-.977H51.632a3.334,3.334,0,0,0-3.33,3.331v7.717a3.334,3.334,0,0,0,3.33,3.33h.528v2.458a1.38,1.38,0,0,0,.873,1.3,1.422,1.422,0,0,0,.53.1,1.355,1.355,0,0,0,.981-.422l3.461-3.442h5.2a3.334,3.334,0,0,0,3.331-3.33v-7.717a3.308,3.308,0,0,0-.977-2.354m.1,10.071a2.461,2.461,0,0,1-2.458,2.458H57.825a.435.435,0,0,0-.308.127l-3.594,3.574a.5.5,0,0,1-.563.121.517.517,0,0,1-.327-.492v-2.894a.436.436,0,0,0-.436-.436h-.965a2.461,2.461,0,0,1-2.458-2.458v-7.717a2.461,2.461,0,0,1,2.458-2.458H63.208a2.462,2.462,0,0,1,2.458,2.458Z",
    transform: "translate(851 71)",
    fill: "#24567b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_461",
    "data-name": "Trac\\xE9 461",
    d: "M65.562,293.514a3.308,3.308,0,0,0-2.354-.977H51.632a3.334,3.334,0,0,0-3.33,3.331v7.717a3.334,3.334,0,0,0,3.33,3.33h.528v2.458a1.38,1.38,0,0,0,.873,1.3,1.422,1.422,0,0,0,.53.1,1.355,1.355,0,0,0,.981-.422l3.461-3.442h5.2a3.334,3.334,0,0,0,3.331-3.33v-7.717A3.308,3.308,0,0,0,65.562,293.514Zm.1,10.071a2.461,2.461,0,0,1-2.458,2.458H57.825a.435.435,0,0,0-.308.127l-3.594,3.574a.5.5,0,0,1-.563.121.517.517,0,0,1-.327-.492v-2.894a.436.436,0,0,0-.436-.436h-.965a2.461,2.461,0,0,1-2.458-2.458v-7.717a2.461,2.461,0,0,1,2.458-2.458H63.208a2.462,2.462,0,0,1,2.458,2.458Z",
    transform: "translate(851 71)",
    fill: "none",
    stroke: "#24567b",
    strokeMiterlimit: 10,
    strokeWidth: 0.567
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_462",
    "data-name": "Trac\\xE9 462",
    d: "M57.277,301.2a.462.462,0,0,0,0,.924.462.462,0,1,0,0-.924",
    transform: "translate(851 71)",
    fill: "#24567b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_463",
    "data-name": "Trac\\xE9 463",
    d: "M57.277,301.2a.462.462,0,0,0,0,.924.462.462,0,1,0,0-.924Z",
    transform: "translate(851 71)",
    fill: "none",
    stroke: "#24567b",
    strokeMiterlimit: 10,
    strokeWidth: 0.283
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_464",
    "data-name": "Trac\\xE9 464",
    d: "M57.366,297.332c-.928,0-1.355.55-1.355.922a.4.4,0,0,0,.413.392c.371,0,.22-.53.921-.53.344,0,.619.151.619.468,0,.371-.385.584-.612.777a1.26,1.26,0,0,0-.461,1.045c0,.358.1.461.379.461.337,0,.4-.151.4-.282a.863.863,0,0,1,.386-.86,1.761,1.761,0,0,0,.77-1.258c0-.647-.585-1.135-1.465-1.135",
    transform: "translate(851 71)",
    fill: "#24567b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_465",
    "data-name": "Trac\\xE9 465",
    d: "M57.366,297.332c-.928,0-1.355.55-1.355.922a.4.4,0,0,0,.413.392c.371,0,.22-.53.921-.53.344,0,.619.151.619.468,0,.371-.385.584-.612.777a1.26,1.26,0,0,0-.461,1.045c0,.358.1.461.379.461.337,0,.4-.151.4-.282a.863.863,0,0,1,.386-.86,1.761,1.761,0,0,0,.77-1.258C58.831,297.82,58.246,297.332,57.366,297.332Z",
    transform: "translate(851 71)",
    fill: "none",
    stroke: "#24567b",
    strokeMiterlimit: 10,
    strokeWidth: 0.283
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_466",
    "data-name": "Trac\\xE9 466",
    d: "M57.421,294.769a4.956,4.956,0,1,0,4.957,4.957,4.963,4.963,0,0,0-4.957-4.957m0,9.041a4.084,4.084,0,1,1,4.084-4.084,4.089,4.089,0,0,1-4.084,4.084",
    transform: "translate(851 71)",
    fill: "#24567b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_467",
    "data-name": "Trac\\xE9 467",
    d: "M57.421,294.769a4.956,4.956,0,1,0,4.957,4.957A4.963,4.963,0,0,0,57.421,294.769Zm0,9.041a4.084,4.084,0,1,1,4.084-4.084A4.089,4.089,0,0,1,57.421,303.81Z",
    transform: "translate(851 71)",
    fill: "none",
    stroke: "#24567b",
    strokeMiterlimit: 10,
    strokeWidth: 0.283
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.3e60066c7c2d3ad1cd4ffef404f512b7.svg";
export { ForwardRef as ReactComponent };